import SecurityConcerns from 'assets/images/icons/psp/boat-storage/SecurityConcerns.svg';
import HighMarinaCosts from 'assets/images/icons/psp/boat-storage/HighMarinaCosts.svg';
import LimitedHomeSpace from 'assets/images/icons/psp/boat-storage/LimitedHomeSpace.svg';
import UVDeterioration from 'assets/images/icons/psp/boat-storage/UVDeterioration.svg';
import WeatherDamage from 'assets/images/icons/psp/boat-storage/WeatherDamage.svg';
import WinterDamage from 'assets/images/icons/psp/boat-storage/WinterDamage.svg';
import OutdoorBoat from 'assets/images/icons/psp/boat-storage/OutdoorBoat.svg';
import CoveredCanopy from 'assets/images/icons/psp/boat-storage/CoveredCanopy.svg';
import IndoorBoat from 'assets/images/icons/psp/boat-storage/IndoorBoat.svg';
import HeatedIndoor from 'assets/images/icons/psp/boat-storage/HeatedIndoor.svg';
import rv from 'assets/images/icons/psp/boat-storage/rv.png';
import ClimateProtection from 'assets/images/icons/psp/boat-storage/ClimateProtection.png';

import featured1 from 'assets/images/psp/FeaturedContentImages/featured1.jpg';
import featured2 from 'assets/images/psp/FeaturedContentImages/featured2.jpg';
import featured3 from 'assets/images/psp/FeaturedContentImages/featured3.webp';
import featured4 from 'assets/images/psp/FeaturedContentImages/featured4.jpg';

import boatHero from 'assets/images/psp/PSPHero/boat-hero.webp';

import { storageCategories } from '../utils/getPSPLinks';

const reviews = [
	{
		title: 'Great service',
		stars: 5,
		text: 'I had to relocate my boat at short notice. Angie was very helpful in helping me to resolve that issue. I was very satisfied with the accommodation of space at the facility we found. This location meets all of my storage and space needs.',
		link: 'https://www.trustpilot.com/reviews/64454a74746ca7dfea0f07e9',
		customerName: 'Stafford Bailey',
		date: 'Apr 23, 2023',
	},
	{
		title: 'This service is convenient and easy to use',
		stars: 5,
		text: 'The site provided the info I needed to find boat storage in my area at a reasonable rate. I was then able to reserve a space immediately before actually talking with anyone. This service is convenient and easy to use.',
		link: 'https://www.trustpilot.com/reviews/616b6e80234f1b1fe55c3604',
		customerName: 'Steve K',
		date: 'Oct 17, 2021',
	},
	{
		title: 'Accurate and Easy',
		stars: 5,
		text: "The site helped locate the type of storage I wanted for my boat, and the after-hours (for the storage facility office) availability of the SelfStorage.com call center helped confirm a reservation once I located the best storage option. It was easy to navigate the site and easy to confirm reservations. The system generated the lead to the facility's staff, who called the following business day to proceed with the rental.",
		link: 'https://www.trustpilot.com/reviews/5f721259798e6f09602220ae',
		customerName: 'Doug',
		date: 'Sep 28, 2020',
	},
	{
		title: 'Easiest part of my move',
		stars: 5,
		text: 'While moving from another state, I was able to set up the entire rental over the phone with SelfStorage.com before I arrived. I then drove straight to the site, dropped off my boat, and proceeded on my way without a problem.',
		link: 'https://www.trustpilot.com/reviews/5f06f4033f06f20a9c98eb82',
		customerName: 'Gary',
		date: 'Jul 9, 2020',
	},
];
const faqs = [
	{
		question: 'What size storage unit do I need for my boat and trailer?',
		answer: 'Most boats with trailers fit in 10x30 or 12x40 units. Pontoon storage typically requires wider units due to their beam width. Measure your boat and trailer combination for the best fit.',
	},
	{
		question: 'Is heated boat storage worth the extra boat storage cost?',
		answer: 'For winter storage longer than 3-4 months, heated storage prevents freeze damage to engines, plumbing, and electronics that could cost thousands to repair.',
	},
	{
		question: 'Can I access my boat anytime during storage?',
		answer: '[Most facilities offer extended or 24/7 access](https://www.selfstorage.com/blog/24-hour-storage-amenities/) so that you can prep your boat for spontaneous water adventures.',
	},
	{
		question: 'How do I prepare my boat for indoor boat storage?',
		answer: 'Clean thoroughly, drain all water systems, add fuel stabilizer, remove electronics, and ensure proper ventilation to prevent moisture buildup.',
	},
	{
		question:
			"What's the difference between boat storage and marina storage?",
		answer: ' Storage facilities focus on long-term protection at lower costs, while marinas offer water access but charge premium rates for slips and often require seasonal contracts.',
	},
	{
		question: 'Do storage facilities accept boats on trailers?',
		answer: 'Yes, most facilities are designed for boat and trailer storage combinations, with wide drive-up access and appropriate unit dimensions.',
	},
	{
		question:
			'Are there restrictions on boat storage box additions or modifications?',
		answer: 'Most facilities allow reasonable storage accessories and covers, but check specific policies about permanent modifications to your storage space.',
	},
	{
		question: 'How far in advance should I book boat storage?',
		answer: 'For winter storage, book 2-3 months ahead as heated boat storage fills up quickly. Summer storage typically has more availability.',
	},
];

export const BoatContent = {
	type: 'Boat',
	reviews: reviews,
	sections: [
		{
			title: 'Boat Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					props: {
						content: {
							title: 'Find Affordable Boat Self Storage',
							description:
								'What if there was a way to stop worrying about your boat sitting exposed in your driveway or taking up precious [garage space](https://www.selfstorage.com/blog/diy-garage-storage/)? Boat storage facilities are the solution you’ve been looking for.\n\nWith indoor and outdoor options to fit every budget, boat storage units protect your watercraft from harsh weather, theft, and UV damage.\n\nWhether you need heated boat storage for the frigid winter months, indoor storage all year round, or a boat trailer park that’s close to your favorite dock, we can connect you to flexible boat storage solutions that work for you, not against you.\n\n **SelfStorage.com** makes it simple to find and reserve the perfect boat storage facility.',
							image: boatHero,
							CTAtext: 'Find Boat Self Storage',
						},
					},
				},
			],
		},
		{
			title: 'Content Section',
			background: 'lighterBlue',
			modules: [
				{
					title: 'Content Section',
					type: 'content',
					props: {
						title: 'How Proper Boat Storage Protects Your Pontoon, Skipper, or Beloved Watercraft',
						contentType: 'row-type',
						theme: 'light',
						content: [
							"You saved up for that beautiful boat to create family memories on the water, but now you're facing the reality of where to store it safely when it's not in use.\n\nYour driveway leaves it exposed to weather and potential theft, your garage wasn't built for boat and trailer storage, and marina fees are eating into your boating budget.",
						],
					},
				},
			],
		},
		{
			title: 'Size Chart 1',
			modules: [
				{
					title: 'Size Chart 1',
					type: 'cardStrip',
					props: {
						heading:
							'Proper Boat Storage Protection Considerations',
						content:
							'Simple boat storage ideas like tarps and basic covers don’t provide enough protection against these risks. Proper boat storage offers comprehensive protection without the expense of building a boat storage box or garage at home.',
						cardData: [
							{
								title: 'Weather Damage',
								content:
									'Sun, rain, snow, and hail cause fading, cracking, and costly repairs\n\n→ [**Indoor boat storage** protects from all weather elements year-round](https://www.selfstorage.com/blog/indoor-boat-storage/)',
								imageSrc: WeatherDamage,
								contentAlign: 'text-left',
							},
							{
								title: 'Limited Home Space',
								content:
									"Most driveways and garages can't accommodate boats and trailers\n\n→ **Right-sized units** designed specifically for watercraft dimensions",
								imageSrc: LimitedHomeSpace,
								contentAlign: 'text-left',
							},
							{
								title: 'UV Deterioration',
								content:
									'Sunlight damages gel coat, upholstery, and electronics\n\n→ **Covered storage** shields your boat from harmful UV radiation',
								imageSrc: UVDeterioration,
								contentAlign: 'text-left',
							},
							{
								title: 'Security Concerns',
								content:
									'Boats in driveways are easy targets for thieves\n\n→ **Gated facilities** with surveillance and controlled access',
								imageSrc: SecurityConcerns,
								contentAlign: 'text-left',
							},
							{
								title: 'Winter Damage',
								content:
									'Freezing temperatures can crack engines and damage systems\n\n→ **Heated boat storage** maintains safe temperatures for sensitive components',
								imageSrc: WinterDamage,
								contentAlign: 'text-left',
							},
							{
								title: 'High Marina Costs',
								content:
									'Slip fees add up quickly, especially for seasonal storage\n\n→ **Affordable alternatives** that cost significantly less than marina storage',
								imageSrc: HighMarinaCosts,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},
		{
			title: 'Content Section',
			background: 'blueWithMap',
			modules: [
				{
					title: 'Content Section',
					type: 'content',
					props: {
						title: 'Boat Storage Solutions & Pricing',
						contentType: 'row-type',
						theme: 'dark',
						content: [
							"When you're managing household expenses, every dollar counts. Professional boat storage offers a smart, budget-friendly alternative that protects your investment without the massive upfront costs associated with construction.",
						],
					},
				},
			],
		},
		{
			title: 'Size Chart 2',
			modules: [
				{
					title: 'Size Chart 2',
					type: 'cardStrip',
					props: {
						heading: 'Boat Storage Unit Size Comparison',
						content:
							'Pricing based on data from **SelfStorage.com**. Average boat storage costs range from $123-$211 monthly, depending on location.',
						cardData: [
							{
								title: 'Outdoor Boat Parking',
								content:
									'**Cost**: $64-$164*\n\n**Best for**: Basic protection, seasonal storage\n\n**Key features**: Fenced lots, boat trailer parking, affordable rates',
								imageSrc: OutdoorBoat,
								contentAlign: 'text-left',
							},
							{
								title: 'Covered/Canopy Storage',
								content:
									'**Cost**:  $100-$200*\n\n**Best for**: Weather protection, UV shielding\n\n**Key features**: Roof coverage, open-air ventilation, easy access',
								imageSrc: CoveredCanopy,
								contentAlign: 'text-left',
							},
							{
								title: 'Indoor Boat Storage',
								content:
									'**Cost**:  $150-$350*\n\n**Best for**: Premium protection, year-round storage\n\n**Key features**: Complete weather protection, security, and climate options',
								imageSrc: IndoorBoat,
								contentAlign: 'text-left',
							},
							{
								title: 'Heated Indoor Storage',
								content:
									'**Cost**:  $200-$400*\n\n**Best for**: Winter storage, luxury boats, pontoon storage\n\n**Key features**: Temperature control, freeze protection, premium security',
								imageSrc: HeatedIndoor,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},
		{
			title: 'Content Section',
			background: 'blueWithMap',
			modules: [
				{
					title: 'Content Section',
					type: 'content',
					props: {
						title: 'How to Measure Your Boat for the Right Storage Unit Size',
						contentType: 'row-type',
						theme: 'dark',
						content: [
							"Before you can choose the right storage unit for your boat, [you need to know what size to reserve](https://www.selfstorage.com/blog/what-to-expect). Getting the right fit saves you money and ensures your boat stores safely\n\nHere's how to measure like a pro:\n\n**Step 1: Measure Overall Length**\n\n> Measure from the bow (front tip) to the stern (back end), including any swim platforms, outboard motors, or trailer tongues.\n\n**Step 2: Check the Beam Width**\n\n> Measure the widest point of your boat. For pontoon storage, this is especially important as pontoons are typically wider than other boat types.\n\n**Step 3: Account for Height**\n\n> Measure from the ground to the highest point, including towers, antennas, or canvas tops. Don't forget trailer height if storing with the trailer.\n\n**Step 4: Add Buffer Space**\n\n> Add 2-3 feet to each dimension for easy maneuvering and access to your boat storage box or equipment.\n\n**Quick Boat Storage Size Guide**\n\n- **Small boats (14-18 ft)**: 10x25 or 10x30 unit\n\n- **Mid-size boats (19-25 ft)**: 12x35 or 12x40 unit\n\n- **Large boats (26+ ft)**: 14x40 or larger custom space\n\n- **Pontoon boats**: Often need 12-14 ft width regardless of length",
						],
					},
				},
			],
		},
		{
			title: 'Size Chart 3',
			modules: [
				{
					title: 'Size Chart 3',
					type: 'cardStrip',
					props: {
						heading:
							'Why Professional Storage Beats DIY Boat Storage Ideas',
						cardData: [
							{
								title: 'RV Boat Storage Convenience',
								content:
									'Many facilities offer [combined RV](https://www.selfstorage.com/blog/long-term-rv-storage-tips-2/), boat, and trailer storage areas, which is perfect if you have multiple recreational vehicles to store.',
								imageSrc: rv,
								contentAlign: 'text-left',
							},
							{
								title: 'Security You Can Trust',
								content:
									'24/7 surveillance, gated access, and individual unit monitoring protect your boat better than DIY home storage solutions.',
								imageSrc: SecurityConcerns,
								contentAlign: 'text-left',
							},
							{
								title: 'No Boat Parking Cost Surprises',
								content:
									'Transparent monthly pricing with no hidden fees. **SelfStorage.com** lets you sort boat storage facilities by cost and other amenities so you know exactly what you’re signing up for. ',
								imageSrc: HighMarinaCosts,
								contentAlign: 'text-left',
							},
							{
								title: 'Climate Protection Options',
								content:
									'Professional [climate controlled](https://www.selfstorage.com/blog/what-is-climate-controlled-storage-2/) or heated boat storage prevents damage and moisture problems that can destroy engines and electronics.',
								imageSrc: ClimateProtection,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							headerTitle: 'Boat Self Storage: ',
							reviews,
						},
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'Boat Self Storage FAQs',
							faqs,
						},
					},
				},
			],
		},
		{
			title: 'featuredContent',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Learn All About Boat Self Storage',
							data: {
								slug: 'boat-related-content',
								unitCards: [
									{
										title: 'Vehicle Storage',
										content:
											'Marina Storage vs. Indoor Storage: Choosing the Right Option for Your Boat',
										date: 'October 10, 2025',
										image: featured1,
										url: 'https://www.selfstorage.com/blog/indoor-boat-storage/',
									},
									{
										content:
											'Best Way to Store a Boat During Off-Season',
										date: 'July 23, 2025',
										image: featured2,
										url: 'https://www.selfstorage.com/blog/how-to-store-a-boat-2/',
										title: 'Vehicle Storage',
									},
									{
										content:
											'The Ultimate Storage Unit Size Guide: Finding the Perfect Fit for Your Storage Needs',
										date: 'October 16, 2025',
										image: featured3,
										url: 'https://www.selfstorage.com/blog/self-storage-unit-size-guide-2/',
										title: 'Storage Tips',
									},
									{
										content:
											'Choosing the Right Storage Unit for Your Vehicle',
										date: 'March 3, 2025',
										image: featured4,
										url: 'https://www.selfstorage.com/blog/car-storage-size-guide/',
										title: 'Vehicle Storage',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						linksList: storageCategories.boat,
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Boat',
					},
				},
			],
		},
	],
};
